module.exports = __webpack_public_path__ + "static/media/reminder-icon.3a4ddc6e.svg";